module.exports = __webpack_public_path__ + "img/card-cbEJ.e5b41b51.svg";